
function initGallerySlider() {
  var $slider = $('.gallery-slider');

  if ($slider.length && !$slider.hasClass('slick-initialized')) {
    $slider.slick({
      infinite: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
             arrows: true
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
}

function initVideoLoaders() {
  var videos = document.querySelectorAll('.gallery-slider video');
  
  videos.forEach(function(video) {
    var loader = video.closest('.gallery-item-link').querySelector('.video-loader');
    if (!loader) return;

    // If the video is already buffered enough to play before the script runs
    if (video.readyState >= 3) {
      loader.style.display = 'none';
    }

    video.addEventListener('waiting', function() {
      loader.style.display = 'block';
    });

    video.addEventListener('playing', function() {
      loader.style.display = 'none';
    });

    video.addEventListener('canplay', function() {
      loader.style.display = 'none';
    });
  });
}


// Initialize on standard page load
$(document).ready(function () {
  initGallerySlider();
  initVideoLoaders();
});

// Initialize when working inside the Shopify Theme Editor
document.addEventListener('shopify:section:load', function() {
  initGallerySlider();
  initVideoLoaders();
});










// For Custom Reviews
$(document).ready(function(){
  // 1. Initialize Slick
  // $('.js-slick-reviews').slick({
  //   dots: false,
  //   arrows: true,
  //   infinite: true,
  //   speed: 300,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   responsive: [
  //     { breakpoint: 1024, settings: { slidesToShow: 2 } },
  //     { breakpoint: 600, settings: { slidesToShow: 1 } }
  //   ]
  // });

  $('.js-slick-reviews').slick({
  dots: false,
  arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,

  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        arrows: false,          
       
      }
    }
  ]
});

  // 2. Read More Functionality
  $('.review-text-content').each(function() {
    var $this = $(this);
    // Check if the actual height is greater than the visible height (7.5em = ~120px)
    if ($this.prop('scrollHeight') > 125) { 
      $this.after('<a class="read-more-btn">Read more...</a>');
    }
  });

  // 3. Click Event
  $(document).on('click', '.read-more-btn', function() {
    var $content = $(this).prev('.review-text-content');
    
    if ($content.hasClass('is-expanded')) {
      $content.removeClass('is-expanded');
      $(this).text('Read more...');
    } else {
      $content.addClass('is-expanded');
      $(this).text('Less');
    }
    
    // Optional: Re-calculate Slick height if using adaptiveHeight
    // $('.js-slick-reviews').slick('setPosition');
  });
});

// ATC animation JS




